import { SubscribedThermostats } from '@energybox/react-ui-library/dist/types';
import {
  isDefined,
  normalizeSubscribedThermostat,
} from '@energybox/react-ui-library/dist/utils';
import assocPath from 'ramda/src/assocPath';
import pipe from 'ramda/src/pipe';
import { Actions as StreamActions } from '../actions/streamApi';

const initialState = {
  byId: {},
};

const subscribedThermostats = (
  state: SubscribedThermostats = initialState,
  action: any
) => {
  switch (action.type) {
    case StreamActions.RECEIVED_DEVICE_READING: {
      if (action.payload.vendor !== 'venstar') {
        return state;
      }

      const normalizedData = normalizeSubscribedThermostat(action.payload);
      const readingType = normalizedData.readingType;

      if (!isDefined(readingType)) {
        return state;
      } else {
        if (
          state.byId[normalizedData.id.toString()] === undefined ||
          Date.parse(normalizedData.timestamp) >
            Date.parse(state.byId[normalizedData.id.toString()].timestamp)
        ) {
          return pipe(assocPath(['byId', action.payload.id], normalizedData))(
            state
          );
        }
        return state;
      }
    }

    default:
      return state;
  }
};

export default subscribedThermostats;
